import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Footer from './Footer';

export default function PublicSiteShell({ children }) {
  const { user, logout } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const adminToken = localStorage.getItem('adminAuthToken');
  const adminUser = JSON.parse(localStorage.getItem('adminUser') || '{}');
  const isAdminLoggedIn = !!adminToken && adminUser.role;

  const getDashboardLink = () => (isAdminLoggedIn ? '/admin' : '/dashboard');
  const getDashboardLabel = () => (isAdminLoggedIn ? 'Admin Panel' : (user?.name ? `Hi, ${user.name.split(' ')[0]}` : 'Dashboard'));

  const handleLogout = () => {
    localStorage.removeItem('adminAuthToken');
    localStorage.removeItem('adminUser');
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    logout();
    navigate('/', { replace: true });
    setTimeout(() => window.location.reload(), 100);
  };

  const NavLinks = () => (
    <>
      <Link to="/" className="text-[#294c79] hover:text-[#1f3a5c] font-medium transition-colors">Home</Link>
      <Link to="/browse" className="text-[#294c79] hover:text-[#1f3a5c] font-medium transition-colors">Browse Homes</Link>
      <Link to="/how-it-works" className="text-[#294c79] hover:text-[#1f3a5c] font-medium transition-colors">How It Works</Link>
      <Link to="/rent-in-ibadan" className="text-[#294c79] hover:text-[#1f3a5c] font-medium transition-colors">Ibadan Rent Guide</Link>
      <Link to="/about" className="text-[#294c79] hover:text-[#1f3a5c] font-medium transition-colors">About</Link>
      <Link to="/contact" className="text-[#294c79] hover:text-[#1f3a5c] font-medium transition-colors">Contact</Link>
    </>
  );

  return (
    <div className="min-h-screen bg-[#fdfdfd] text-[#1a1a1a] flex flex-col">
      <header className="sticky top-0 z-50 bg-white border-b border-[#afc09e] shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex-shrink-0">
              <img src="/Logo.jpg" alt="LiteRent Logo" className="h-12 sm:h-14 md:h-16 w-auto object-contain" />
            </Link>

            <nav className="hidden lg:flex items-center space-x-7 xl:space-x-9">
              <NavLinks />
              <div className="flex items-center space-x-4">
                {(user || isAdminLoggedIn) ? (
                  <>
                    <Link to={getDashboardLink()}>
                      <button className={`px-6 py-2.5 text-white rounded-full font-medium transition shadow-sm ${isAdminLoggedIn ? 'bg-red-600 hover:bg-red-700' : 'bg-[#294c79] hover:bg-[#1f3a5c]'}`}>
                        {getDashboardLabel()}
                      </button>
                    </Link>
                    <button onClick={handleLogout} className="px-6 py-2.5 border-2 border-red-500 text-red-600 rounded-full font-medium hover:bg-red-50 transition">
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link to="/login"><button className="px-6 py-2.5 border-2 border-[#294c79] text-[#294c79] rounded-full font-medium hover:bg-[#294c79]/10 transition">Login</button></Link>
                    <Link to="/signup"><button className="px-6 py-2.5 bg-[#a5c250] text-white rounded-full font-medium hover:bg-[#8bb83a] shadow-sm transition">Get Started</button></Link>
                  </>
                )}
              </div>
            </nav>

            <button className="lg:hidden p-2 rounded-md text-[#294c79] hover:bg-gray-100 focus:outline-none" onClick={() => setMenuOpen(v => !v)} aria-label="Toggle menu">
              <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {menuOpen
                  ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />}
              </svg>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden bg-white border-t border-[#afc09e] py-6 px-5">
            <div className="flex flex-col space-y-5">
              <NavLinks />
              <div className="pt-6 border-t border-gray-200 flex flex-col space-y-4">
                {(user || isAdminLoggedIn) ? (
                  <>
                    <Link to={getDashboardLink()} onClick={() => setMenuOpen(false)}><button className={`w-full py-4 text-white rounded-full font-medium text-lg ${isAdminLoggedIn ? 'bg-red-600' : 'bg-[#294c79]'}`}>{getDashboardLabel()}</button></Link>
                    <button onClick={() => { handleLogout(); setMenuOpen(false); }} className="w-full py-4 border-2 border-red-500 text-red-600 rounded-full font-medium text-lg">Logout</button>
                  </>
                ) : (
                  <>
                    <Link to="/login" onClick={() => setMenuOpen(false)}><button className="w-full py-4 border-2 border-[#294c79] text-[#294c79] rounded-full font-medium text-lg">Login</button></Link>
                    <Link to="/signup" onClick={() => setMenuOpen(false)}><button className="w-full py-4 bg-[#a5c250] text-white rounded-full font-medium text-lg">Get Started</button></Link>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </header>

      <div className="flex-1">{children}</div>
      <Footer />
    </div>
  );
}
